(function () {
  'use strict';

  var GATEWAY = 'https://checkout.velnexcenter.com';
  var SHOP = (window.Shopify && window.Shopify.shop) || window.MERIDIAN_SHOP || '';
  var I18N = window.MeridianI18n;
  var pspChoices = [];
  var selectedPsp = '';
  // 's2s': our own card fields post the PAN to the gateway, which routes it to
  // Redsys / Nexi / Comercia. 'hosted': legacy acquirer iframe.
  var cardMode = 's2s';
  var cardUi = null;
  function t(key) { return I18N ? I18N.t(key) : key; }
  function euros(cents) { return I18N ? I18N.euros(cents) : ((cents / 100).toFixed(2) + ' \u20ac'); }
  function err(code) {
    var map = {
      CARD_DECLINED: t('err_card'),
      INVALID_EMAIL: t('err_email'),
      INVALID_ADDRESS: t('err_address'),
      NO_SHIPPING: t('err_shipping'),
      EMPTY_CART: t('err_empty'),
      INVALID_ITEM: t('err_item'),
      SESSION_LOCKED: t('err_locked'),
      INVALID_AMOUNT: t('err_amount'),
    };
    return map[code] || '';
  }

  var state = { cart: null, shipping: null, quoteToken: 0 };

  function $(id) { return document.getElementById(id); }

  if (I18N) {
    I18N.apply(document);
    if (I18N.applyEnglishPolicies) I18N.applyEnglishPolicies(document);
  }

  /* ---------- Order summary ---------- */

  function renderSummary() {
    var template = $('sc-summary-template');
    var cart = state.cart;
    var subtotal = cart.total_price;
    var shipping = state.shipping;
    var total = subtotal + (shipping ? shipping.price_cents : 0);

    document.querySelectorAll('[data-summary-clone]').forEach(function (host) {
      if (!host.childElementCount) {
        host.appendChild(template.content.cloneNode(true));
      }
      host.querySelectorAll('[data-i18n]').forEach(function (el) {
        if (el.hasAttribute('data-subtotal') || el.hasAttribute('data-total') || el.hasAttribute('data-shipping')) return;
        el.textContent = t(el.getAttribute('data-i18n'));
      });

      var list = host.querySelector('[data-items]');
      list.innerHTML = '';
      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'sc-item';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        li.innerHTML =
          '<span class="sc-item-media">' +
            (item.image
              ? '<img src="' + item.image + '&width=120" alt="" loading="lazy">'
              : '<span class="sc-item-placeholder"></span>') +
            '<span class="sc-item-qty">' + item.quantity + '</span>' +
          '</span>' +
          '<span class="sc-item-info">' +
            '<span class="sc-item-title">' + item.product_title + '</span>' +
            (variant ? '<span class="sc-item-variant">' + variant + '</span>' : '') +
          '</span>' +
          '<span class="sc-item-price">' + euros(item.final_line_price) + '</span>';
        list.appendChild(li);
      });

      host.querySelector('[data-subtotal]').textContent = euros(subtotal);

      var shipEl = host.querySelector('[data-shipping]');
      if (!shipping) {
        shipEl.textContent = t('enter_address');
        shipEl.classList.add('sc-muted');
      } else {
        shipEl.textContent = shipping.price_cents === 0 ? t('free') : euros(shipping.price_cents);
        shipEl.classList.remove('sc-muted');
      }

      host.querySelector('[data-total]').textContent = euros(total);
    });

    $('sc-msummary-total').textContent = euros(total);
  }

  /* ---------- Shipping quote ---------- */

  function addressReady(form) {
    return !!(form.elements.country_code.value && form.elements.zip.value.trim() && form.elements.city.value.trim()
      && form.elements.address1.value.trim());
  }

  async function refreshQuote(form) {
    var box = $('sc-ship-rate');
    var note = $('sc-ship-empty');
    if (!addressReady(form)) {
      state.shipping = null;
      box.hidden = true;
      note.hidden = false;
      renderSummary();
      return;
    }
    var token = ++state.quoteToken;
    try {
      var res = await fetch(GATEWAY + '/shopify/storefront/quote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shop: SHOP,
          country_code: form.elements.country_code.value,
          items: state.cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }),
        }),
      });
      var json = await res.json();
      if (token !== state.quoteToken) return;
      if (!res.ok || !json.shipping) throw new Error(json.code || 'quote');
      state.shipping = json.shipping;
      var ship = I18N && I18N.shippingLabel
        ? I18N.shippingLabel(json.shipping.title)
        : { title: json.shipping.title || t('standard_shipping'), subtitle: t('ship_eta') };
      $('sc-ship-name').textContent = ship.title;
      $('sc-ship-price').textContent = json.shipping.price_cents === 0 ? t('free') : euros(json.shipping.price_cents);
      var subEl = $('sc-ship-sub');
      if (subEl) {
        subEl.textContent = ship.subtitle;
        subEl.hidden = !ship.subtitle;
      }
      note.hidden = true;
      box.hidden = false;
      renderSummary();
    } catch (error) {
      if (token !== state.quoteToken) return;
      state.shipping = null;
      box.hidden = true;
      note.hidden = false;
      note.textContent = error.message === 'NO_SHIPPING' ? t('err_shipping') : t('ship_empty');
      renderSummary();
    }
  }

  /* ---------- Field helpers ---------- */

  function setProvinces(form) {
    if (I18N) {
      I18N.setProvinces(form);
      I18N.applyFieldLabels(form);
      return;
    }
  }

  function attachCardFormatting() {}

  function markError(input, bad) {
    var field = input.closest('.sc-field');
    if (field) field.classList.toggle('has-error', !!bad);
  }

  function validate(form, silent) {
    var problems = [];
    var checks = [
      [form.elements.email, /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.elements.email.value.trim()), t('err_email')],
      [form.elements.first_name, !!form.elements.first_name.value.trim(), t('err_address')],
      [form.elements.last_name, !!form.elements.last_name.value.trim(), t('err_address')],
      [form.elements.address1, !!form.elements.address1.value.trim(), t('err_address')],
      [form.elements.city, !!form.elements.city.value.trim(), t('err_address')],
      [form.elements.zip, !!form.elements.zip.value.trim(), t('err_address')],
    ];
    checks.forEach(function (check) {
      if (!silent) markError(check[0], !check[1]);
      if (!check[1]) problems.push({ input: check[0], message: check[2] });
    });
    return problems;
  }

  /* ---------- Errors / busy ---------- */

  function showError(message) {
    var box = $('sc-error');
    $('sc-error-text').textContent = message;
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideError() { $('sc-error').hidden = true; }

  function setBusy(busy) {
    var btn = $('sc-submit');
    if (!btn) return;
    btn.classList.toggle('is-busy', busy);
    btn.disabled = busy;
    var label = $('sc-submit-label');
    if (label) label.textContent = busy ? t('processing') : t('pay_now');
  }

  /* ---------- Submit: hosted Redsys page served by the gateway ---------- */

  var FRAME_ORIGIN = 'https://checkout.velnexcenter.com';
  var insiteOrder = '';
  var armedSession = '';
  var armedAmount = '';
  var mountedKey = '';
  var arming = false;
  var embedForm = null;
  var embedLoads = 0;
  var embedFullTimer = null;
  var embedFinished = false;
  var embedScrollAnchor = 0;
  var embedInitialScrollGuarded = false;
  var embedUserScrolled = false;

  function payFrame() { return $('sc-pay-frame'); }
  function rsEmbed() { return $('sc-rs-embed'); }

  function setPayStatus(kind, message) {
    var placeholder = $('sc-pay-ph');
    var text = $('sc-pay-ph-text');
    var cover = $('sc-rs-cover');
    if (kind === 'ready') {
      if (placeholder) placeholder.hidden = true;
      if (cover) cover.hidden = true;
      return;
    }
    if (kind === 'idle') {
      if (cover) cover.hidden = true;
      if (placeholder && text) {
        placeholder.hidden = false;
        placeholder.classList.remove('is-error');
        placeholder.classList.add('is-msg');
        text.textContent = message || t('psp_pick');
      }
      return;
    }
    if (kind === 'loading') {
      if (placeholder) placeholder.hidden = true;
      if (cover) cover.hidden = false;
      return;
    }
    if (cover) cover.hidden = true;
    if (placeholder && text) {
      placeholder.hidden = false;
      placeholder.classList.remove('is-msg');
      placeholder.classList.toggle('is-error', kind === 'error');
      text.textContent = message || t('pay_load');
    }
  }

  function pinInitialScroll() {
    if (embedInitialScrollGuarded) return;
    embedInitialScrollGuarded = true;
    var y = embedScrollAnchor;
    var active = true;
    var onScroll = function () {
      if (!active || embedUserScrolled) return;
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo(window.scrollX, y);
    };
    var stop = function () {
      active = false;
      window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    requestAnimationFrame(onScroll);
    setTimeout(stop, 3000);
    ['wheel', 'touchmove', 'keydown', 'pointerdown'].forEach(function (ev) {
      window.addEventListener(ev, stop, { once: true, passive: true });
    });
  }

  function enterEmbedFullscreen() {
    var embed = rsEmbed();
    if (!embed || embed.classList.contains('is-full')) return;
    var section = embed.closest('.sc-reveal');
    if (section) section.style.animation = 'none';
    embed.classList.add('is-full');
    document.body.classList.add('is-rs-full');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var exit = $('sc-rs-exit');
    if (exit) exit.hidden = false;
  }

  function exitEmbedFullscreen() {
    var embed = rsEmbed();
    if (!embed) return;
    embed.classList.remove('is-full');
    document.body.classList.remove('is-rs-full');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    var exit = $('sc-rs-exit');
    if (exit) exit.hidden = true;
  }

  function submitEmbed(hosted, force) {
    var frame = payFrame();
    var embed = rsEmbed();
    if (!frame || !embed || !hosted || !hosted.action || !hosted.fields) return;
    var key = armedSession + ':' + armedAmount;
    if (!force && key === mountedKey && embed.classList.contains('is-on')) return;
    mountedKey = key;
    if (selectedPsp !== 'addonpayments') document.body.classList.add('is-rs-embed');
    embed.classList.add('is-on');
    if (!('credentialless' in HTMLIFrameElement.prototype) && navigator.vendor !== 'Apple Computer, Inc.') {
      try {
        if (localStorage.getItem('rs_modulo_visto') === '1') embed.classList.add('is-safe');
        localStorage.setItem('rs_modulo_visto', '1');
      } catch (e) { /* ignore */ }
    }
    if (embedForm) embedForm.remove();
    embedForm = document.createElement('form');
    embedForm.method = 'POST';
    embedForm.action = hosted.action;
    embedForm.target = hosted.target || 'sc-pay-frame';
    embedForm.style.display = 'none';
    Object.keys(hosted.fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = hosted.fields[name] || '';
      embedForm.appendChild(input);
    });
    document.body.appendChild(embedForm);
    setPayStatus('loading');
    embedLoads = 0;
    embedFinished = false;
    embedScrollAnchor = window.scrollY;
    embedForm.submit();
    pinInitialScroll();
    setTimeout(function () { setPayStatus('ready'); }, 4000);
  }

  function checkoutPayload(form) {
    var data = new FormData(form);
    var email = String(data.get('email') || '').trim();
    var country = String(data.get('country_code') || (I18N && I18N.locale.country) || '').trim();
    var fallback = I18N ? I18N.cityFallback(country) : { city: 'Milano', zip: '20100' };
    var payload = {
      shop: SHOP,
      locale: I18N ? I18N.locale.lang : 'fr',
      redsys_order: insiteOrder || undefined,
      items: state.cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }),
      email: email.indexOf('@') > 0 ? email : ('checkout@' + (location.hostname || 'shop.local')),
      shipping: {
        first_name: String(data.get('first_name') || '').trim() || t('customer'),
        last_name: String(data.get('last_name') || '').trim() || t('customer'),
        address1: String(data.get('address1') || '').trim() || t('address_pending'),
        address2: String(data.get('address2') || '').trim(),
        city: String(data.get('city') || '').trim() || fallback.city,
        zip: String(data.get('zip') || '').trim() || fallback.zip,
        province: String(data.get('province') || '').trim(),
        country_code: country,
        phone: String(data.get('phone') || '').trim(),
      },
    };
    if (selectedPsp) payload.psp = selectedPsp;
    return payload;
  }

  async function startSession(form, force, options) {
    options = options || {};
    var payload = checkoutPayload(form);
    if (options.payMethods) payload.pay_methods = options.payMethods;
    var res = await fetch(GATEWAY + '/shopify/storefront/start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    var json = await res.json().catch(function () { return {}; });
    if (!res.ok || !json.session_id) {
      throw new Error(err(json.code) || json.message || t('pay_failed'));
    }
    armedSession = json.session_id;
    armedAmount = String(json.amount_cents || '');
    insiteOrder = String(json.redsys_order || insiteOrder);
    if (json.card_mode) cardMode = json.card_mode;
    setWalletReady(true);
    if (options.mount === false || cardMode === 's2s') return json;
    if (!json.hosted || !json.hosted.action) {
      throw new Error(t('pay_load'));
    }
    var topLevel = json.hosted.target === '_top' || json.hosted.target === '_parent';
    if (topLevel && !force) return json;
    submitEmbed(json.hosted, !!force);
    return json;
  }

  /* ---------- Layer 1: unified card component ---------- */

  function mountCardUi() {
    var host = $('sc-card-ui');
    if (!host || cardUi || !window.Meridian) return;
    host.hidden = false;
    var embed = rsEmbed();
    if (embed) embed.classList.remove('is-on');
    document.body.classList.remove('is-rs-embed');
    setPayStatus('ready');
    cardUi = window.Meridian.mount({
      el: host,
      button: false,
      labels: {
        cardNumber: t('card_number'),
        expiry: t('card_expiry'),
        cvc: t('card_cvc'),
        nameOnCard: t('card_name'),
        declined: t('pay_declined'),
        network: t('network'),
        cancel: t('cancel_pay'),
      },
      onError: function (message) { if (message) showError(message); },
    });
  }

  // Layer 1 submit: authorize server-to-server, then let the component open the
  // layer-2 overlay if the issuer asks for a one-time code.
  async function payWithCard(form) {
    var problem = cardUi.valid();
    if (problem) {
      showError(problem);
      return;
    }
    var json = await startSession(form, true, { mount: false });
    var card = cardUi.values();
    var res = await fetch(GATEWAY + '/shopify/storefront/pay', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: SHOP,
        session_id: json.session_id,
        pan: card.pan,
        expiry: card.expiry,
        cvv: card.cvv,
        name: card.name,
        browser: {
          javaEnabled: false,
          language: navigator.language,
          colorDepth: screen.colorDepth,
          screenHeight: screen.height,
          screenWidth: screen.width,
          timezoneOffset: new Date().getTimezoneOffset(),
        },
      }),
    });
    var body = await res.json().catch(function () { return {}; });
    if (!res.ok) throw new Error(err(body.code) || body.message || t('pay_declined'));
    cardUi.reset();
    if (body.status === 'authorized' && body.confirmation_url) {
      window.location.href = body.confirmation_url;
      return;
    }
    if (body.status === 'challenge' && body.challenge_url) {
      var outcome = await window.Meridian.challenge(body.challenge_url, {
        statusUrl: body.status_url,
        labels: { authenticating: t('bank_connecting'), cancel: t('cancel_pay'), declined: t('pay_declined') },
      });
      if (outcome.status === 'authorized') {
        window.location.href = outcome.url || body.confirmation_url;
        return;
      }
      throw new Error(t('pay_declined'));
    }
    throw new Error(t('pay_declined'));
  }

  function renderPspChooser() {
    var box = $('sc-psp');
    var cardHead = $('sc-paybox-card-head');
    if (!box) return;
    var dual = pspChoices.length > 1;
    document.body.classList.toggle('is-psp-choose', dual);
    box.hidden = !dual;
    if (cardHead) cardHead.hidden = dual;
    if (!dual) return;
    var buttons = box.querySelectorAll('.sc-psp-btn');
    for (var i = 0; i < buttons.length; i += 1) {
      var btn = buttons[i];
      var kind = btn.getAttribute('data-psp') || '';
      btn.hidden = pspChoices.indexOf(kind) < 0;
      btn.classList.toggle('is-on', kind === selectedPsp);
    }
    var hint = $('sc-psp-hint');
    if (hint) {
      var redirects = selectedPsp === 'nexi' && cardMode !== 's2s';
      if (!selectedPsp) hint.textContent = t('psp_pick');
      else if (redirects) hint.textContent = t('psp_nexi_hint');
      else hint.textContent = '';
      hint.hidden = !redirects;
    }
  }

  async function loadPspChoices() {
    try {
      var res = await fetch(GATEWAY + '/shopify/storefront/insite-config?shop=' + encodeURIComponent(SHOP), {
        headers: { Accept: 'application/json' },
      });
      var json = await res.json().catch(function () { return {}; });
      if (res.ok && json.choices && json.choices.length) pspChoices = json.choices.slice();
      else if (json.psp) pspChoices = [json.psp];
      if (res.ok && json.card_mode) cardMode = json.card_mode;
    } catch (e) { /* keep empty */ }
    if (SHOP.indexOf('x0zpz8-00') >= 0 && pspChoices.length < 2) {
      pspChoices = ['addonpayments', 'nexi'];
    }
    renderPspChooser();
    if (pspChoices.length > 1 && !selectedPsp) setPayStatus('idle', t('psp_pick'));
  }

  function setWalletReady(ready) {
    ['sc-apple-pay', 'sc-google-pay'].forEach(function (id) {
      var btn = $(id);
      if (btn) btn.disabled = !ready;
    });
  }

  function walletEmbed() { return $('sc-wallet-embed'); }
  function walletFrame() { return $('sc-wallet-frame'); }

  // L'overlay iframe per i wallet non viene più usato (Apple Pay richiede un
  // contesto top-level, vedi payWithWallet): resta solo la pulizia difensiva.
  function closeWalletOverlay() {
    var embed = walletEmbed();
    var frame = walletFrame();
    var cover = $('sc-wallet-cover');
    if (embed) {
      embed.hidden = true;
      embed.classList.remove('is-full');
    }
    document.body.classList.remove('is-rs-full');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (cover) cover.hidden = false;
    if (frame) {
      try { frame.src = 'about:blank'; } catch (e) { /* ignore */ }
    }
    setBusy(false);
    setWalletReady(true);
  }

  // Apple Pay sulla pagina Redsys funziona SOLO in un contesto top-level (Apple
  // blocca il flusso dentro un iframe cross-origin — rifiuto immediato, Redsys
  // registra 9915). Google Pay nell'iframe funzionerebbe, ma per coerenza i
  // wallet aprono entrambi sis.redsys.es in un VERO popup: il popup va aperto in
  // modo sincrono nel click (prima di qualsiasi await) o Safari lo blocca.
  var walletPopup = null;
  var walletPollTimer = null;

  function closeWalletPopup() {
    if (walletPollTimer) { clearInterval(walletPollTimer); walletPollTimer = null; }
    if (walletPopup && !walletPopup.closed) {
      try { walletPopup.close(); } catch (e) { /* already cross-origin */ }
    }
    walletPopup = null;
  }

  function walletPopupLoading(popup) {
    try {
      popup.document.open();
      popup.document.write(
        '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">'
        + '<title>' + t('pay_title') + '</title></head><body style="margin:0;min-height:100vh;display:flex;align-items:center;'
        + 'justify-content:center;background:#f6f6f6;color:#333;font:14px -apple-system,BlinkMacSystemFont,\'Segoe UI\',sans-serif">'
        + '<p>' + t('wallet_connecting') + '</p></body></html>'
      );
      popup.document.close();
    } catch (e) { /* popup already navigated cross-origin */ }
  }

  function openWalletPopup(hosted) {
    if (!walletPopup || walletPopup.closed) return;
    var esc = function (value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    };
    var inputs = Object.keys(hosted.fields).map(function (name) {
      return '<input type="hidden" name="' + esc(name) + '" value="' + esc(hosted.fields[name]) + '">';
    }).join('');
    walletPopup.document.open();
    walletPopup.document.write(
      '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">'
      + '<title>' + t('pay_title') + '</title></head><body style="margin:0;min-height:100vh;display:flex;align-items:center;'
      + 'justify-content:center;background:#f6f6f6;color:#333;font:14px -apple-system,BlinkMacSystemFont,\'Segoe UI\',sans-serif">'
      + '<p>' + t('wallet_connecting') + '</p>'
      + '<form id="sc-wf" method="POST" action="' + esc(hosted.action) + '">' + inputs + '</form>'
      + '<script>document.getElementById("sc-wf").submit();<\/script></body></html>'
    );
    walletPopup.document.close();
  }

  async function payWithWallet(form) {
    hideError();
    var problems = validate(form);
    if (problems.length) {
      showError(problems[0].message);
      problems[0].input.focus();
      return;
    }
    closeWalletPopup();
    var width = Math.min(520, window.screen.availWidth || 520);
    var height = Math.min(820, window.screen.availHeight || 820);
    var left = Math.max(0, Math.round(((window.screen.availWidth || width) - width) / 2));
    var top = Math.max(0, Math.round(((window.screen.availHeight || height) - height) / 2));
    walletPopup = window.open(
      '',
      'meridian_wallet',
      'popup=yes,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top
    );
    if (!walletPopup) {
      showError(t('popup_blocked'));
      return;
    }
    walletPopupLoading(walletPopup);
    setBusy(true);
    setWalletReady(false);
    walletPollTimer = setInterval(function () {
      if (!walletPopup || walletPopup.closed) {
        closeWalletPopup();
        setBusy(false);
        setWalletReady(true);
      }
    }, 500);
    try {
      var json = await startSession(form, true, { payMethods: 'xpay', mount: false });
      if (!json.hosted || !json.hosted.action) throw new Error(t('wallet_fail'));
      if (!walletPopup || walletPopup.closed) {
        closeWalletPopup();
        setBusy(false);
        setWalletReady(true);
        return;
      }
      openWalletPopup(json.hosted);
      setBusy(false);
    } catch (error) {
      closeWalletPopup();
      var msg = error && error.message ? String(error.message) : '';
      if (!msg || /failed to fetch|networkerror|load failed/i.test(msg)) {
        msg = t('network');
      }
      showError(msg);
    }
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== FRAME_ORIGIN) return;
    var data = event.data || {};
    if (data.meridian === 'height' && data.value) {
      var frame = payFrame();
      if (frame) frame.style.height = Math.max(560, Number(data.value) + 8) + 'px';
    }
    if (data.meridian === 'result' || data.redsys) {
      var payload = data.meridian === 'result' ? data : data.redsys;
      var status = String(payload.status || '');
      var url = payload.url || payload.redirectUrl;
      if ((status === 'authorized' || status === 'processing') && url) {
        embedFinished = true;
        closeWalletPopup();
        window.location.href = url;
        return;
      }
      if (status === 'declined') {
        embedFinished = true;
        exitEmbedFullscreen();
        closeWalletOverlay();
        closeWalletPopup();
        setBusy(false);
        mountedKey = '';
        showError(t('pay_declined'));
        var declinedForm = $('sc-form');
        if (declinedForm && !validate(declinedForm, true).length) {
          startSession(declinedForm, true).catch(function () {});
        }
      }
    }
  });

  async function submit(form) {
    hideError();
    if (pspChoices.length > 1 && !selectedPsp) {
      showError(t('psp_pick'));
      setPayStatus('idle', t('psp_pick'));
      return;
    }
    var problems = validate(form);
    if (problems.length) {
      showError(problems[0].message);
      problems[0].input.focus();
      return;
    }

    setBusy(true);
    try {
      if (cardMode === 's2s') {
        if (!cardUi) mountCardUi();
        if (!cardUi) throw new Error(t('pay_load'));
        await payWithCard(form);
      } else {
        await startSession(form, true);
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      var msg = error && error.message ? String(error.message) : '';
      if (!msg || /failed to fetch|networkerror|load failed/i.test(msg)) {
        msg = t('network');
      }
      showError(msg);
    }
  }

  /* ---------- Init ---------- */

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  async function loadShipTo() {
    if (!I18N || !I18N.setShipTo) return;
    try {
      var res = await fetch(GATEWAY + '/shopify/storefront/shipping-countries?shop=' + encodeURIComponent(SHOP), {
        headers: { Accept: 'application/json' },
      });
      var json = await res.json().catch(function () { return {}; });
      if (res.ok && json.countries) I18N.setShipTo(json.countries, json.shop_country);
    } catch (e) { /* keep empty until retry */ }
  }

  async function init() {
    await loadShipTo();
    await loadPspChoices();
    try {
      state.cart = await (await fetch('/cart.js')).json();
    } catch (error) {
      showError(t('cart_load'));
      return;
    }
    if (!state.cart.items || !state.cart.items.length) {
      window.location.href = '/cart';
      return;
    }

    if (I18N) I18N.apply(document);
    renderPspChooser();
    if (pspChoices.length > 1 && !selectedPsp) setPayStatus('idle', t('psp_pick'));
    renderSummary();

    var toggle = $('sc-msummary-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var wrap = $('sc-msummary');
        var open = wrap.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    var form = $('sc-form');
    if (!form) return;
    if (I18N) {
      I18N.fillCountries(form.elements.country_code);
      if (I18N.locale.country) form.elements.country_code.value = I18N.locale.country;
    }
    setProvinces(form);
    attachCardFormatting(form);

    var quote = debounce(function () { refreshQuote(form); }, 450);
    ['country_code', 'zip', 'city', 'address1'].forEach(function (name) {
      form.elements[name].addEventListener('input', quote);
      form.elements[name].addEventListener('change', quote);
    });
    form.elements.country_code.addEventListener('change', function () { setProvinces(form); });

    form.addEventListener('input', function (event) {
      if (event.target.closest('.sc-field.has-error')) markError(event.target, false);
    });

    function tryArm() {
      if (!state.cart || arming) return;
      // Layer 1 has nothing to pre-arm: the session is created on submit.
      if (cardMode === 's2s') {
        mountCardUi();
        return;
      }
      if (pspChoices.length > 1 && (!selectedPsp || selectedPsp === 'nexi')) return;
      if (mountedKey && rsEmbed() && rsEmbed().classList.contains('is-on')) return;
      arming = true;
      var embed = rsEmbed();
      if (embed) embed.classList.add('is-on');
      setPayStatus('loading');
      startSession(form, false).then(function () {
        hideError();
        arming = false;
      }).catch(function (error) {
        arming = false;
        if (embed) embed.classList.remove('is-on');
        var msg = error && error.message ? String(error.message) : t('pay_load');
        if (/failed to fetch|networkerror|load failed/i.test(msg)) {
          msg = t('network');
        }
        setPayStatus('error', msg);
        showError(msg);
      });
    }

    var pspBox = $('sc-psp');
    if (pspBox) {
      pspBox.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-psp]');
        if (!btn) return;
        var kind = btn.getAttribute('data-psp') || '';
        if (pspChoices.indexOf(kind) < 0) return;
        selectedPsp = kind;
        mountedKey = '';
        armedSession = '';
        var embed = rsEmbed();
        if (embed) embed.classList.remove('is-on');
        var frame = payFrame();
        if (frame) frame.src = 'about:blank';
        document.body.classList.remove('is-rs-embed');
        renderPspChooser();
        // Only the hosted fallback still sends the shopper to the Nexi page.
        if (kind === 'nexi' && cardMode !== 's2s') {
          setPayStatus('idle', t('psp_nexi_hint'));
          return;
        }
        tryArm();
      });
      pspBox.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var btn = event.target.closest('[data-psp]');
        if (!btn) return;
        event.preventDefault();
        btn.click();
      });
    }
    if (pspChoices.length > 1) {
      var wallets = $('sc-wallets');
      if (wallets) wallets.hidden = true;
    }

    refreshQuote(form);

    var arm = debounce(tryArm, 400);
    form.addEventListener('input', arm);
    form.addEventListener('change', arm);
    form.addEventListener('focusout', arm);
    setInterval(tryArm, 700);
    setTimeout(tryArm, 50);
    setTimeout(tryArm, 400);
    setTimeout(tryArm, 1200);

    if (new URLSearchParams(window.location.search).get('error')) {
      showError(t('threeds_failed'));
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submit(form);
    });

    function onWalletClick() { payWithWallet(form); }
    var apple = $('sc-apple-pay');
    var google = $('sc-google-pay');
    if (apple) apple.addEventListener('click', onWalletClick);
    if (google) google.addEventListener('click', onWalletClick);

    ['wheel', 'touchmove', 'keydown', 'pointerdown'].forEach(function (ev) {
      window.addEventListener(ev, function () { embedUserScrolled = true; }, { passive: true });
    });

    var embed = rsEmbed();
    if (embed) {
      embed.addEventListener('scroll', function () {
        if (embed.classList.contains('is-full')) return;
        if (embed.scrollTop !== 0) embed.scrollTop = 0;
        if (embed.scrollLeft !== 0) embed.scrollLeft = 0;
      }, { passive: true });
    }

    var frame = payFrame();
    if (frame) {
      frame.addEventListener('load', function () {
        setPayStatus('ready');
        embedLoads += 1;
        if (embedLoads >= 2) {
          clearTimeout(embedFullTimer);
          embedFullTimer = setTimeout(function () {
            if (!embedFinished && selectedPsp !== 'addonpayments') enterEmbedFullscreen();
          }, 550);
        }
      });
    }

    var exit = $('sc-rs-exit');
    if (exit) {
      exit.addEventListener('click', function () {
        exitEmbedFullscreen();
        mountedKey = '';
        startSession(form, true).catch(function () {});
      });
    }

    var wallet = walletFrame();
    if (wallet) {
      wallet.addEventListener('load', function () {
        var cover = $('sc-wallet-cover');
        var embed = walletEmbed();
        if (!embed || embed.hidden) return;
        try {
          if (wallet.contentWindow && wallet.contentWindow.location.href === 'about:blank') return;
        } catch (e) { /* cross-origin: Redsys loaded */ }
        if (cover) cover.hidden = true;
      });
    }
    var walletExit = $('sc-wallet-exit');
    if (walletExit) {
      walletExit.addEventListener('click', function () { closeWalletOverlay(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
